import { render, staticRenderFns } from "./LocationSettings.vue?vue&type=template&id=4a8b4770"
import script from "./LocationSettings.vue?vue&type=script&lang=js"
export * from "./LocationSettings.vue?vue&type=script&lang=js"
import style0 from "./LocationSettings.vue?vue&type=style&index=0&id=4a8b4770&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports